import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreateRoleDocument } from './create.generated';

export const useCreateRole = (options: ApiOptions<typeof CreateRoleDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(CreateRoleDocument, {
    ...useNotifications(CreateRoleDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.roles.create_success'),
    }),

    ...options,
  });
};
